module.exports = __webpack_public_path__ + "img/main-thunder.a2582c3b.svg";